import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import InvoiceFilter from '../components/filters/invoice-filter';
import InvoicesTable from '../components/tables/invoices-table';

const InvoicesListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="فاکتور ها"
      style={{ padding: " 16px 0" }}
      onBack={() => navigate(-1)}
    />
    
    <InvoiceFilter onFinish={setFitlers} />
    <InvoicesTable filters={filters} />
  </>);
}

export default InvoicesListRoute;
